module.exports = __webpack_public_path__ + "img/br43.33e6d14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br43.jpg
// module id = DRu6
// module chunks = 0